import {configureStore} from "@reduxjs/toolkit";
import {persistStore, persistReducer} from "redux-persist";
import storage from "redux-persist/lib/storage";
import rootReducer from "./reducer";

const persistConfig = {
    key: "root",
    storage,
    whitelist: ["config", "user", "setting", 'home'], 
};

export function createStore(preloadedState?: any, usePersist = true) {
    const reducer = usePersist ? persistReducer(persistConfig, rootReducer) : rootReducer;

    const store = configureStore({
        reducer,
        preloadedState,
        middleware: (getDefaultMiddleware) => getDefaultMiddleware({serializableCheck: false}),
    });

    const persistor = usePersist ? persistStore(store) : null;

    return {store, persistor};
}
